import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';

import { ImageSelector } from '../../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-group',
  templateUrl: 'group.html',
  providers : [HttpClient, CustomToast]
})
export class GroupPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  group = {
    id : -1,
    name_es : '',
    name_en : '',
    description_es : '',
    description_en : '',
    image : '',
    coordinator_id : -1,
    active: 0,
  };

  active;

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  customToast : CustomToast;
  events : Events;
  alertCtrl : AlertController;

  users;

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events,alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();

    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;
    let id = navParams.get('id');
    this.httpCallGroup(id);

    this.httpCallPeopleByGroup(id);
	}

  httpCallGroup(id){
    this.httpClient.get('/groups/'+id,(error,data)=>{
      if(!error){
        this.group = data.json();
        this.active = this.group.active ? true : false;
        this.image.filename = this.group.image;
      }
    });
  }

  httpCallPeopleByGroup(id){
    this.httpClient.get('/users/group/'+id,(error,data)=>{
      this.users = data.json();
    });
  }

  onClickSave(){
    this.httpUpdateGroup();
  }

  httpUpdateGroup(){
    
    if(!this.group.name_es || !this.group.description_es || ! this.group.coordinator_id || !this.group.image){
      this.customToast.showMessage('La imagen y los campos con * son necesarios',2000);
    }else{
      this.group.active = this.active == true ? 1 : 0;
    this.httpClient.put('/groups',this.group,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Grupo actualizado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('group:update');
      }
    });
  }
  }

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.group.image = image.filename;
      }
    });
  }

  // onClickDelete(){
  //   let alert = this.alertCtrl.create({
  //     title : '¿Estas seguro?',message : 'Vas a eliminar la información de este grupo',
  //     buttons:[{
  //       text : 'No',
  //       role : 'cancel'
  //       },
  //       {
  //       text : 'Si',
  //       role : 'confirm',
  //         handler : ()=>{
  //           this.httpCallDelete();
  //         }
  //       }
  //     ]
  //   });
  //   alert.present();
  // }

  // httpCallDelete(){
  //   this.httpClient.delete('/groups/'+this.group.id,(error,data)=>{
  //     if(!error){
  //       this.customToast.showMessage('Grupo eliminado correctamente',2000);
  //       this.navCtrl.pop();
  //       this.events.publish('group:delete');
  //     }
  //   });
  // }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/groups/group/group.ts